// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"345":"fce9ed45","456":"093eede9","656":"d6fd69a0","756":"7d6213aa","787":"0b189af4","968":"e12f8161"}[chunkId] + ".chunk.js";
};